// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { logoStyles } from "@vanmeter/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        width: 131px;
        height: 44px;
        ${xScreen("lte", "md")} {
            width: 112px;
            height: 38px;
        }
        & .home-page-link {
            width: 100%;
            height: 100%;
        }

        ${TypographyStyle} {
            line-height: 0;
            display: block;
            width: 100%;
            height: 100%;
        }
    `,
};
